import React from 'react'
import 'regenerator-runtime/runtime'
import Settings from '../../routes/Profile/Settings'

const Routes = () => {
  if (typeof window === 'undefined') return null
  return <Settings />
}

export default Routes
